import * as CONST from 'Reducers/Users/const'

/**
 * Get Users
 *
 */
export function getUsers() {
  return {
    type: CONST.GET_USERS,
  }
}

/**
 * Get User by id
 *
 * @param userId
 */
export function getUserById(userId) {
  return {
    type: CONST.GET_USER_BY_ID,
    userId,
  }
}

/**
 * Create User
 *
 * @param payload
 * @param callbacks
 * @returns {{type, callbacks: *, payload: *}}
 */
export function createUser(payload, callbacks) {
  return {
    type: CONST.CREATE_USER,
    payload,
    callbacks,
  }
}

/**
 * Update User
 *
 * @param userId
 * @param callbacks
 * @param payload
 * @returns {{type, callbacks: *, userId: *, payload: *}}
 */
export function updateUserById(userId, payload, callbacks) {
  return {
    type: CONST.UPDATE_USER_BY_ID,
    userId,
    callbacks,
    payload,
  }
}

/**
 * Set filter client
 *
 * @param {string} clientId
 * @returns {{type, payload: {clientId: string}}}
 */
export function setFilterClient(clientId) {
  return {
    type: CONST.USERS_SET_FILTER_CLIENT,
    payload: {
      clientId: clientId,
    },
  }
}

/**
 * Set filter status
 *
 * @param {string} status
 * @returns {{type, payload: {status: string}}}
 */
export function setFilterStatus(status) {
  return {
    type: CONST.USERS_SET_FILTER_STATUS,
    payload: {
      status: status,
    },
  }
}

/**
 * Set filter role
 *
 * @param {string} role
 * @returns {{type, payload: {role: string}}}
 */
export function setFilterRole(role) {
  return {
    type: CONST.USERS_SET_FILTER_ROLE,
    payload: {
      role,
    },
  }
}

/**
 * Set users sort by
 *
 * @param sortBy
 * @returns {{type, sortBy: *}}
 */
export function setUsersSortBy(sortBy) {
  return {
    type: CONST.USERS_SET_SORT_BY,
    usersSortBy: sortBy,
  }
}

/**
 * Delete user by id
 *
 * @param {number} userId
 * @returns {{type, id: number}}
 */
export function deleteUser(userId) {
  return {
    type: CONST.USER_DELETE,
    payload: { userId },
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Users/actions.js